module.exports = __webpack_public_path__ + "static/3-7f1bacd2a09b59e0d31f37cc8284f87b.jpg";